export default __webpack_public_path__ + "static/media/480_dummy2016-restaurant04-de.d8000a39.png";